module.exports = __webpack_public_path__ + "media/images/animations/overhight_load/1-84322588a8fd74fafbc5143968476b01.png";